import * as React from "react";
import { useReducer, useEffect } from "react";
import { Row, Col, Button, Input } from 'reactstrap';
import InfiniteScroll from 'react-infinite-scroller';
import { LookupItem } from "../Models/LookupItem";
import { FacetResult } from "../Models/FacetResult";

export type SearchFilter = {
    Keywords: string;
    Category: string;
    Branch: string;
    SortByField: string;
    SortASC: boolean,
    Path: string;
}

type NVKBListingResultState = {

    items: NVKBItem[];
    totalItems: number;
    isNoResults: boolean;
    isLoading: boolean;
    canLoadMore: boolean;
    searchFilter: SearchFilter;
}


const initialState: NVKBListingResultState = {
    items: [],
    totalItems: 0,
    isNoResults: false,
    isLoading: false,
    canLoadMore: false,
    searchFilter: undefined
}

const EventsListingResult = (props: {
    searchFilter: SearchFilter,
    searchByCategory: (category: string) => void,
    searchByBranch: (category: string, branch: string) => void
}) => {

    let [state, setState] = useReducer(
        (prevState: NVKBListingResultState, newState: Partial<NVKBListingResultState>) => ({ ...prevState, ...newState }),
        initialState
    );

    const search = () => {
        if ((props.searchFilter) && (props.searchFilter.Category))
            console.log('in search filter - cat ', props.searchFilter.Category ? props.searchFilter.Category : 'undefined');
        //console.log('in search filter - branch ', props.searchFilter.Branch ? props.searchFilter.Branch : 'undefined');
        if ((!props.searchFilter) || (!props.searchFilter.Category && !props.searchFilter.Keywords)) {
            setState({
                items: [],
                totalItems: 0,
                isNoResults: false,
                isLoading: false,
                canLoadMore: false,
                searchFilter: undefined
            });
            return;
        }

        setState({ isLoading: true, canLoadMore: false });

        serviceCall(props.searchFilter, 0)
            .then(x =>
                setState({
                    items: x.items,
                    isNoResults: x.items.length == 0,
                    canLoadMore: x.totalItems > x.items.length,
                    isLoading: false
                })
            );

    }

    const loadMore = () => {

        setState({ isLoading: true, canLoadMore: false });

        serviceCall(props.searchFilter, state.items.length)
            .then(x => {

                let updatedItems = state.items.concat(x.items);

                setState({
                    items: updatedItems,
                    canLoadMore: x.totalItems > updatedItems.length,
                    isLoading: false
                });
            }
            );
    }

    const serviceCall = (sf: SearchFilter, offset: number): Promise<FacetResult<NVKBItem>> => {

        let payload = { ...sf, offset, pageSize: 10 };

        return fetch('/cpaapi/nvkb', {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        }).then(res => res.json());

    };


    // update on new search filter
    useEffect(() => {
        search();
    }, [props.searchFilter]);

    return <InfiniteScroll
        pageStart={0}
        loadMore={loadMore}
        hasMore={state.canLoadMore && !state.isLoading}
    >
        {state.items.map(x => <NVKBListingItem key={x.NodeId}
            item={x}
            searchByBranch={props.searchByBranch}
            searchByCategory={props.searchByCategory}
        />)}
    </InfiniteScroll>
}

const NVKBListingItem = (props: {
    item: NVKBItem,
    searchByCategory: (category: string) => void,
    searchByBranch: (category: string, branch: string) => void
}) => {

    return <div className="news-listing-item">
        {props.item.Url && props.item.Url.length > 0 && <a target="_blank" href={props.item.Url} className="img-container float-right">
            <img src={props.item.Thumbnail} alt={props.item.ThumbnailAlt} className="img-fluid" />
        </a>}    
        <div className="news-body">
            <div className="mb-2">
                {props.item.Category && <span className="category cursor-pointer" onClick={() => props.searchByCategory(props.item.CategoryId)} style={{
                    backgroundColor: props.item.Category.BackgroundColor,
                    color: props.item.Category.TextColor
                }}>{props.item.Category.Name}</span>}{props.item.Branches.map(x => <span className="audience" /*onClick={() => props.searchByBranch(props.item.CategoryId, x.Value)}*/>{x.Title}</span>)} 
            </div>
            <a target="_blank" href={props.item.Url} className="event-title">{props.item.Title}</a>
            <div className="summary" dangerouslySetInnerHTML={{ __html: props.item.Summary}}></div>
            <div className="event-bottom">
                <span className="author">By <b>{props.item.Author}</b></span>                
                <span className="date">{props.item.DateAsString}</span>                
                {/*<span className="addthis_toolbox d-inline" data-addthis-url={props.item.Url} data-addthis-title={props.item.Title}>
                    <span className="custom_images">
                        <a className="addthis_button_more"><span className="btn-share">Share</span></a>
                    </span>
                </span>*/}

            </div>
        </div>

        <div className="clearfix"></div>
    </div>;
}

export class NVKBItem {
    Author: string;
    Category: CategoryModel;
    CategoryId: string;
    Branches: LookupItem[];
    DateAsString: string;
    Thumbnail: string;
    ThumbnailAlt: string;
    //Media: string;
    //Branch: string;
    Summary: string;
    Title: string;
    NodeId: number;
    Url: string;
}

class CategoryModel {
    Name: string;
    BackgroundColor: string;
    TextColor: string;
}

export default EventsListingResult;
